<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="actionType=='fields'?'字段权限':'维度权限'"
        :close-on-press-escape="false"
        width="800px"
        append-to-body
        :before-close="handleClose">
        <div class="content-box">
            <div class="group-item-1" :class="isMultipleCol?'multiple-col pl20':''" v-for="group1 in fieldsData" :key="group1.id">
                <div class="group-title mt10 mb10">
                    <el-checkbox
                        :indeterminate="group1.indeterminate"
                        :disabled="group1.disabled||group1.default_check=='1'"
                        v-model="group1.checked"
                        @change="handleCheck(group1.id, $event)">
                        <span>{{group1.display_name}}</span>
                    </el-checkbox>
                </div>
                <div class="group-content">
                    <template v-for="group2 in group1.children">
                        <div class="test222 ml20" v-if="group2.children&&group2.children.length>1">
                            <div class="group-title mt10 mb10">
                                <el-checkbox
                                    :indeterminate="group2.indeterminate"
                                    :disabled="group2.disabled"
                                    v-model="group2.checked"
                                    @change="handleCheck(group2.id, $event)">
                                    <span>{{group2.display_name}}</span>
                                </el-checkbox>
                            </div>
                            <div class="group-content">
                                <template v-for="group3 in group2.children">
                                    <div class="test222 ml20" v-if="group3.children&&group3.children.length>1">

                                    </div>
                                    <el-checkbox
                                        class="ml40 mb6"
                                        v-else
                                        :disabled="group3.disabled"
                                        :indeterminate="group3.indeterminate"
                                        v-model="group3.checked"
                                        @change="handleCheck(group3.id, $event)">
                                        <span>{{group3.display_name}}</span>
                                    </el-checkbox>
                                </template>
                            </div>
                        </div>
                        <el-checkbox
                            class="ml40 mb6"
                            v-else
                            :indeterminate="group2.indeterminate"
                            :disabled="group2.disabled"
                            v-model="group2.checked"
                            @change="handleCheck(group2.id, $event)">
                            <span>{{group2.display_name}}</span>
                        </el-checkbox>
                    </template>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="cancelSubmit" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>

    import util from '@/libs/utils';

    export default {
        name: "BatchRemoveFields",
        components: {},
        props: {
            fields: {
                type: Array,
                required: true
            },
            page:{
                type: Object,
                required: true
            },
            actionType:{
                type: String,
                required: true
            }
        },
        watch: {
            fields: {
                handler(new_value) {
                    this.fieldsData = this._fmtTreeData(util.deepClone(new_value));
                    this.oldData = this._fmtTreeData(util.deepClone(this.fieldsData));
                },
                deep: true,
                immediate: true
            }
        },
        data() {
            return {
                dialogVisible: false,
                fieldsData: this.fields,
                oldData:[],
            }
        },
        computed: {
            isMultipleCol(){
                /* 特殊页面需要把维度改为一行多列： 苹果渠道下的系列广告组、系列广告*/
                let spePageList = ['apple_org','apple_campaign'];
                return this.actionType=='dimensions'&&spePageList.includes(this.page.name);
            },
        },
        mounted() {
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetData();
            },
            showModal() {
                this.dialogVisible = true;
            },
            resetData() {
                this.fieldsData =  this._fmtTreeData(util.deepClone(this.oldData));
            },
            handleCheck(id, val) {
                console.log('handleCheck',id,val,this.page);
                let targetCheck = this._findModuleById(this.fieldsData, id);

                if(!val&&this.page.checked) {
                    console.log(111111111111,targetCheck);
                    targetCheck.checked = true;
                    return false;
                }

                /*根节点：没有父级*/
                let isRoot = !this._findModuleById(this.fieldsData,targetCheck.pid);

                /* 叶节点：没有children为叶节点 */
                let isLeaf = !targetCheck.children||((targetCheck.children||[]).length<=0);

                if(isLeaf){
                    this.$set(targetCheck,'checked',val);
                    this._setParentIndeterminate(targetCheck);
                }else if(isRoot){
                    this.$set(targetCheck,'indeterminate',false);
                    this._setChildrenChecked(targetCheck,val);
                }else{
                    /*又有父节点，又有子节点*/

                    this._setChildrenChecked(targetCheck,val);
                    this._setParentIndeterminate(targetCheck);
                }
            },
            _removeParentsChecked(module){
                let pid = module.pid;
                if(!pid) return;
                let targetModule =  this._findModuleById(this.fieldsData,pid);
                if(targetModule){
                    this.$set(targetModule,'checked',false);
                    this._removeParentsChecked(targetModule);
                }
            },
            cancelSubmit(){
                this.dialogVisible = false;
                this.resetData();
            },
            handleSubmit() {
                let actionIds = this._getCheckedVal(this.fieldsData,[]);
                this.oldData = this._fmtTreeData(util.deepClone(this.fieldsData));
                console.log('save-fields',this.page,actionIds);
                this.$emit('save-fields',this.page,actionIds,this.actionType);
                this.handleClose();
            },
            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _setParentIndeterminate(module){
                let childFields = (module.children||[]).filter(item=>!item.disabled);
                if(childFields.length>0) {

                    if(childFields.every(field => field.indeterminate===undefined)){
                        this.$set(module,'indeterminate',childFields.some(field => field.checked)&&childFields.some(field => !field.checked));
                    }else{
                        if(childFields.some(field => field.indeterminate)) {
                            this.$set(module,'indeterminate',true);
                        }else if(childFields.every(field => field.checked)||childFields.every(field => !field.checked)){
                            this.$set(module,'indeterminate',false);
                        }else{
                            this.$set(module,'indeterminate',true);
                        }
                    }
                }
                let pid = module.pid;
                let pModule = this._findModuleById(this.fieldsData,pid);
                if(pModule){
                    this._setParentIndeterminate(pModule);
                }
            },
            _setChildrenChecked(module,val){
                let childFields = (module.children||[]).filter(item=>!item.disabled);
                if(val){
                    module.checked = val;
                    if(module.indeterminate!==undefined){
                        module.indeterminate = false;
                    }
                }else{
                    module.checked = val;
                    module.indeterminate = false;
                }
                childFields.forEach(item=>{
                    this._setChildrenChecked(item,val);
                });
            },
            _fmtTreeData(data) {
                data.forEach((v) => {
                    let childFields = v.children||[];
                    if(childFields.some(field => field.indeterminate)||(childFields.some(field => field.checked) && childFields.some(field => !field.checked))){
                        this.$set(v, 'indeterminate', true);
                    }
                    if (childFields.length > 0) {

                        // if(v.checked===undefined){
                        //     this.$set(v, 'checked', childFields.length > 0 && childFields.every(field => field.checked));
                        // }
                        // if(v.indeterminate===undefined){
                        //     this.$set(v, 'indeterminate', childFields.some(field => field.checked) && childFields.some(field => !field.checked));
                        // }
                        this._fmtTreeData(childFields)
                    }
                });
                return data;
            },
            _getCheckedVal(list,result){
                list.forEach(item=>{
                    if(item.checked){
                        result.push(item.id);
                    }
                    if(item.children&&item.children.length>0){
                        return this._getCheckedVal(item.children,result);
                    }
                });
                return result;
            },
        }
    }
</script>

<style scoped>
    .content-box{
        max-height: 320px;
        overflow-y: auto;
    }
    .action-btn {
        width: 120px;
    }

    .group-title {
        font-weight: bold;
    }

    .field-checkbox {
        margin: 5px 10px;
        width: 120px;
        white-space: nowrap;
    }

    .multiple-col{
        display: inline-block;
        min-width: 180px;
    }
</style>
